"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";
import { useMemo } from "react";

import { formatWorkingHoursHtml } from "@shared/utils/format-working-hours";

import s from "./working-hours.module.scss";

export type WorkingHoursProps = ComponentProps<"div"> & {
  className?: string;
  workingHours?: string | null;
  ascentTime?: string | null;
  descentTime?: string | null;
};

export const WorkingHours = (props: WorkingHoursProps) => {
  const { className, workingHours, ascentTime, descentTime } = props;

  const htmlContent = useMemo(
    () => formatWorkingHoursHtml(workingHours, ascentTime, descentTime),
    [workingHours, ascentTime, descentTime],
  );

  if (!htmlContent) {
    return null;
  }

  return (
    <div
      className={clsx(s.root, className)}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

WorkingHours.displayName = "WorkingHours";
